import { Suspense } from 'react'
import { Outlet, ScrollRestoration } from 'react-router'
import { isDemoCatalog } from '@/catalog/load'
import { PageLoader } from '@/components/ui/Spinner'
import { SiteFooter } from './SiteFooter'
import { SiteHeader } from './SiteHeader'

export function RootLayout() {
  return (
    <div className="flex min-h-dvh flex-col">
      <a
        href="#main"
        className="sr-only z-50 rounded-full bg-volt px-4 py-2 font-semibold text-volt-ink focus:not-sr-only focus:fixed focus:top-3 focus:left-3"
      >
        Skip to content
      </a>
      {isDemoCatalog && (
        <div className="bg-amber/15 py-1.5 text-center text-xs font-medium text-amber">
          Demo catalog — sample entries for layout testing, not real games.
        </div>
      )}
      <SiteHeader />
      <main id="main" className="flex-1">
        <Suspense fallback={<PageLoader />}>
          <Outlet />
        </Suspense>
      </main>
      <SiteFooter />
      <ScrollRestoration />
    </div>
  )
}
